import '../polyfills/element.isInViewport.js';
import '../polyfills/element.fitsWrapper.js';
import '../polyfills/intersectionObserver.js';
import { fetchCall } from '../utils/fetchCall.js';
import { Cookie } from '../utils/Cookie.js';
import { setMode } from '@stencil/core';

setMode(() => {
  const isRTL = !!document.querySelector('.rtl');

  if (document.body.classList.contains('theme--rebrand')) {
    return isRTL ? 'rtl_rebrand' : 'rebrand';
  }
  if (document.body.classList.contains('theme--prime')) {
    return isRTL ? 'rtl_prime' : 'prime';
  }
  if (document.body.classList.contains('theme--investments')) {
    return isRTL ? 'rtl_investments' : 'investments';
  }
  if (document.body.classList.contains('theme--helpandsupport')) {
    return isRTL ? 'rtl_helpandsupport' : 'helpandsupport';
  }
  if (document.body.classList.contains('theme--academy')) {
    return isRTL ? 'rtl_academy' : 'academy';
  }
  if (document.body.classList.contains('theme--landingpages')) {
    return isRTL ? 'rtl_landingpages' : 'landingpages';
  }
  if (document.body.classList.contains('theme--generic')) {
    return isRTL ? 'rtl_generic' : 'generic';
  }
  return isRTL ? 'rtl' : 'default';
});

window.PSC = window.PSC || {};
window.PSC.fetchCall = fetchCall;
window.PSC.Cookie = new Cookie();
